import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

import type { SessionState } from "../features/auth/session";
import { ErrorPage } from "../features/home/ErrorPage";
import { NotFoundPage } from "../features/home/NotFoundPage";

export type RouterContext = {
  session: SessionState;
  queryClient: QueryClient;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  notFoundComponent: NotFoundPage,
  errorComponent: ErrorPage,
});
